import { EnvironmentService } from '@/services/environment';
import { SentryService } from '@/services/sentry';
import { setupDayjsExtensions } from '@/utils/setupDayjsExtensions';
import { Big } from 'big.js';

EnvironmentService.init();
SentryService.init();

Big.RM = 2;
Big.DP = 10;

setupDayjsExtensions();
